<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            New {{title}}
            <div class="text-small">
                {{masterTab.description}}
            </div>
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card-body p-2" *ngIf="!masterTab.isUpload && masterTab.keyName !== 'division'">
                <ng-select [items]="[]" [addTag]="true" [multiple]="true" [selectOnTab]="true"
                    placeholder="Type in to save" [isOpen]="false" [(ngModel)]="dropdownValue">
                </ng-select>
            </div>
            <div  class="p-2" *ngIf="!masterTab.isUpload && masterTab.keyName === 'plant_code'">
                <div class="col-12 row">
                    <div class="col-12">
                        <input type="checkbox" (change)="handleCheckboxChange($event)">
                        <label class="form-label p-1" for="column.headerName">
                            On Behalf Supplier
                        </label>
                    </div>
                </div>
            </div>
            <div class="card-body p-2" *ngIf="!masterTab.isUpload && masterTab.keyName === 'division'">
                <div class="col-12 row">
                    <div class="col-6">
                        <input type="text" class="form-control form-control-sm" id="Division" placeholder="Division"
                            [(ngModel)]="division_name">
                    </div>
                    <div class="col-6">
                        <input type="number" class="form-control form-control-sm" id="Threshold" placeholder="Threshold"
                            [(ngModel)]="threshold" (keypress)="blockInvalidChar($event)">
                    </div>
                </div>
            </div>
            <div class="card-body p-2" *ngIf="masterTab.isUpload">
                <div class="file-upload">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-sm-12 col-md-12 pt-3 position-relative">
                            <div class="upload-container">
                                <div class="upload-icon mx-3">
                                    <span class="fa fa-cloud-upload fa-5x"></span>
                                </div>
                                <div class="upload-title mx-3">
                                    <p>
                                        {{ uploadFiles[0]?.file?.name || "Drag and drop the PR file to upload"}}
                                    </p>
                                </div>
                                <input type="file" #inputFile id="choose" (change)="onUploadFile($event)" />
                            </div>
                            <div class="text-center my-3">
                                <a class="btn btn-outline-primary btn-lg" (click)="inputFile.click()">
                                    Choose File
                                </a>
                                <a class="btn btn-outline-danger btn-lg mx-2" (click)="uploadFiles=[]"
                                    *ngIf="uploadFiles?.length">
                                    Clear File
                                </a>
                            </div>
                            <div class="upload-instructions mt-4 text-start">
                                <h6>Upload Instructions: </h6>
                                <ul>
                                    <li class='font-small'>
                                        1. Only xls, xlsx file format is supported
                                    </li>
                                    <li class='font-small'>
                                        2. During file upload, total size of the file must not exceed 20MB
                                    </li>
                                    <li class='font-small'>
                                        3. Only one file can be uploaded at a time
                                    </li>
                                </ul>
                                <div>
                                    <a class="text-small text-decoration-none cursor-pointer"
                                        download="{{download_file_name}}" href="{{template_name}}">
                                        <span class="fa fa-download pe-2"></span>
                                        <span>Download template file for {{title}}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button class="btn btn-outline-primary mx-2" (click)="bsModalRef.hide()">Cancel</button>
            <button class="btn btn-primary mx-2 text-white" (click)="updateInfo()" [disabled]="
                    (!dropdownValue.length && !masterTab.isUpload && masterTab.keyName !== 'division')
                    ||
                    (!uploadFiles.length && masterTab.isUpload)
                    ||
                    (!division_name && !masterTab.isUpload && !threshold && masterTab.keyName === 'division')
                ">
                Save
            </button>
        </div>
    </div>
</section>